// Content for all 36 city pages. Edit this file to change any city page.
// "near" lists URL slugs of other cities we serve that are close by (they become links).
// IMPORTANT: verify the ZIP codes before publishing, and replace or extend "local" with
// real details from your own jobs there (neighborhoods, common appliance brands, a customer review).

export const cityUrl = (slug) => `/illinois-service-area/appliance-repair-${slug}-illinois`;

export const CITY_DATA = {
  "addison": {
    name: "Addison", county: "DuPage", zips: ["60101"],
    near: ["elmhurst", "villa-park", "wheaton"],
    intro: "Addison homeowners and landlords call us when a refrigerator stops cooling, a washer won't drain or an oven won't heat. We offer same-day visits in most cases and quote the repair before any work begins.",
    local: "Addison is a village in northeast DuPage County, bordering Elmhurst and Villa Park.",
  },
  "arlington-heights": {
    name: "Arlington Heights", county: "Cook", zips: ["60004", "60005"],
    near: ["prospect-heights", "schaumburg", "barrington"],
    intro: "From single-family homes to condominiums and apartment buildings, Arlington Heights has appliances of every size and age. We repair compact stackable washers and dryers as well as full-size kitchen appliances.",
    local: "Arlington Heights is a large northwest suburb in Cook County with a walkable downtown and a mix of older homes and newer condominiums.",
  },
  "bartlett": {
    name: "Bartlett", county: "DuPage", zips: ["60103"],
    near: ["schaumburg", "addison", "barrington"],
    intro: "Busy Bartlett families rely on their dishwashers, washers and dryers every day, so a breakdown cannot wait. We diagnose the problem on the first visit and tell you the cost before starting the repair.",
    local: "Bartlett spans parts of Cook, DuPage and Kane counties in the northwest suburbs.",
  },
  "barrington": {
    name: "Barrington", county: "Cook", zips: ["60010"],
    near: ["arlington-heights", "schaumburg", "bartlett"],
    intro: "Barrington homes often have premium and built-in appliances, and we are comfortable working on both standard and high-end brands. Our technicians explain the problem clearly and recommend repair or replacement honestly.",
    local: "Barrington is a northwest suburb in Cook and Lake counties, near the larger properties of Barrington Hills.",
  },
  "bolingbrook": {
    name: "Bolingbrook", county: "Will", zips: ["60440", "60490"],
    near: ["romeoville", "naperville", "plainfield"],
    intro: "Bolingbrook is only a short drive from our Plainfield headquarters, which helps us offer quick appointments. We repair refrigerators, washers, dryers, dishwashers, ovens, stoves and wine coolers for homes and small businesses.",
    local: "Bolingbrook straddles Will and DuPage counties and is one of the larger suburbs in the southwest area.",
  },
  "burr-ridge": {
    name: "Burr Ridge", county: "DuPage", zips: ["60527"],
    near: ["hinsdale", "darien", "lemont"],
    intro: "Larger homes in Burr Ridge tend to have more and higher-end appliances, from built-in refrigerators to professional-style ranges. We service Sub-Zero, Thermador, Wolf, Viking, Miele and other premium brands, along with everyday models.",
    local: "Burr Ridge lies along the DuPage and Cook county line, with a mix of larger homes and newer developments.",
  },
  "crest-hill": {
    name: "Crest Hill", county: "Will", zips: ["60403"],
    near: ["lockport", "shorewood", "plainfield"],
    intro: "When a dryer stops heating or a stove burner won't light in Crest Hill, you want a technician who can come out quickly. We offer same-day service in most cases and give a clear quote before we replace anything.",
    local: "Crest Hill is a Will County city right next to Joliet.",
  },
  "clarendon-hill": {
    name: "Clarendon Hills", county: "DuPage", zips: ["60514"],
    near: ["hinsdale", "western-springs", "downers-grove"],
    intro: "Many homes in Clarendon Hills are established houses with appliances that have been running for years. We repair them where it makes sense and tell you plainly if replacing is the better value.",
    local: "Clarendon Hills is a small DuPage County village with a Metra station and a walkable downtown.",
  },
  "crestwood": {
    name: "Crestwood", county: "Cook", zips: ["60445"],
    near: ["orland-park", "palos-heights", "hickory-hills"],
    intro: "Crestwood residents can count on us for dependable repair of refrigerators, ovens, washers and dryers. Each visit includes a full inspection, an upfront quote and a warranty on the repair.",
    local: "Crestwood is a southwest Cook County village near Alsip and Midlothian.",
  },
  "darien": {
    name: "Darien", county: "DuPage", zips: ["60561"],
    near: ["downers-grove", "burr-ridge", "lemont"],
    intro: "A leaking dishwasher or a washer that won't spin can cause real damage if you wait. Our Darien service covers repairs for all major brands, with transparent pricing and no surprises.",
    local: "Darien is a city in southern DuPage County, close to Downers Grove and Woodridge.",
  },
  "downers-grove": {
    name: "Downers Grove", county: "DuPage", zips: ["60515", "60516"],
    near: ["darien", "lisle", "clarendon-hill"],
    intro: "Downers Grove has a wide range of housing, from older homes to newer builds, and we repair the appliances in all of them. Call us for refrigerator, dishwasher, washer, dryer, oven and stove problems.",
    local: "Downers Grove is a DuPage County suburb with a lively downtown and Metra service.",
  },
  "elmhurst": {
    name: "Elmhurst", county: "DuPage", zips: ["60126"],
    near: ["villa-park", "addison", "elmwood-park"],
    intro: "Elmhurst homes range from historic houses to modern remodels, and each has its own appliance needs. We repair standard and built-in units and we always give you the price before we begin.",
    local: "Elmhurst is a DuPage County suburb that is home to Elmhurst University and a walkable downtown.",
  },
  "elmwood-park": {
    name: "Elmwood Park", county: "Cook", zips: ["60707"],
    near: ["elmhurst", "villa-park", "addison"],
    intro: "Elmwood Park has many older homes and two-flats, where compact and older appliances are common. We repair them carefully, and we will tell you honestly when a repair no longer makes sense.",
    local: "Elmwood Park is a compact village on Chicago's western edge in Cook County.",
  },
  "glen-ellyn": {
    name: "Glen Ellyn", county: "DuPage", zips: ["60137"],
    near: ["wheaton", "lisle", "villa-park"],
    intro: "Glen Ellyn residents choose us for careful, tidy repairs and clear communication. We treat your home with respect and leave the work area clean when we finish.",
    local: "Glen Ellyn is a DuPage County village known for Lake Ellyn and its historic downtown.",
  },
  "hickory-hills": {
    name: "Hickory Hills", county: "Cook", zips: ["60457"],
    near: ["palos-hills", "crestwood", "orland-park"],
    intro: "If your refrigerator is warm, your oven is cold or your washer is stuck mid-cycle, our Hickory Hills service can help. We offer same-day appointments in most cases and a warranty on every repair.",
    local: "Hickory Hills is a southwest Cook County city near Palos Hills and Oak Lawn.",
  },
  "hinsdale": {
    name: "Hinsdale", county: "DuPage", zips: ["60521"],
    near: ["clarendon-hill", "burr-ridge", "western-springs"],
    intro: "Hinsdale homeowners often own premium appliances that deserve careful service. We work on Sub-Zero, Wolf, Thermador, Miele, Viking and other high-end brands, as well as standard models.",
    local: "Hinsdale is an established village in DuPage and Cook counties known for its historic downtown.",
  },
  "homer-glen": {
    name: "Homer Glen", county: "Will", zips: ["60491"],
    near: ["lockport", "new-lenox", "orland-park"],
    intro: "Homer Glen homes tend to have larger residential lots and plenty of appliances to match. We repair refrigerators, freezers, ovens, washers and dryers, and we quote every repair before starting.",
    local: "Homer Glen is a Will County village in the southwest suburbs with larger residential lots.",
  },
  "lemont": {
    name: "Lemont", county: "Cook", zips: ["60439"],
    near: ["burr-ridge", "darien", "lockport"],
    intro: "Lemont has a mix of historic homes in the old village and newer neighborhoods on the hills above it. Whatever the age of your appliances, we can diagnose the problem and recommend the right fix.",
    local: "Lemont is a historic village built along the Illinois and Michigan Canal and known for its limestone heritage.",
  },
  "lisle": {
    name: "Lisle", county: "DuPage", zips: ["60532"],
    near: ["naperville", "downers-grove", "glen-ellyn"],
    intro: "Lisle residents and local businesses call us for fast, honest appliance repair. We handle residential and commercial refrigerators, washers, dryers, dishwashers and ovens.",
    local: "Lisle is a DuPage County village, and the Morton Arboretum is located there.",
  },
  "lockport": {
    name: "Lockport", county: "Will", zips: ["60441"],
    near: ["crest-hill", "homer-glen", "romeoville"],
    intro: "Lockport has plenty of older homes with appliances that have served for years. We repair them when it is worth it and give straight advice on replacement when it is not.",
    local: "Lockport is a Will County city on the Illinois and Michigan Canal with a historic downtown.",
  },
  "mokena": {
    name: "Mokena", county: "Will", zips: ["60448"],
    near: ["new-lenox", "orland-park", "homer-glen"],
    intro: "Mokena families need appliances that work on a busy schedule. We offer same-day repair in most cases for refrigerators, ovens, dishwashers, washers and dryers.",
    local: "Mokena is a Will County village in the southwest suburbs with a Metra station on the Rock Island line.",
  },
  "naperville": {
    name: "Naperville", county: "DuPage and Will", zips: ["60540", "60563", "60564", "60565"],
    near: ["bolingbrook", "lisle", "plainfield"],
    intro: "Naperville is one of the largest suburbs we serve, and its homes range from established neighborhoods to new construction. We repair refrigerators, washers, dryers, dishwashers, ovens, stoves and wine coolers throughout the city.",
    local: "Naperville spans DuPage and Will counties and is known for its downtown and the Riverwalk.",
  },
  "new-lenox": {
    name: "New Lenox", county: "Will", zips: ["60451"],
    near: ["mokena", "homer-glen", "shorewood"],
    intro: "New Lenox continues to grow, and many of its homes have newer appliances with electronic controls and sensors. We diagnose these modern units as well as older ones, and we explain the problem in plain language.",
    local: "New Lenox is a growing Will County village along the Rock Island Metra line.",
  },
  "oak-brook": {
    name: "Oak Brook", county: "DuPage", zips: ["60523"],
    near: ["hinsdale", "burr-ridge", "elmhurst"],
    intro: "Oak Brook homeowners often have high-end kitchens, and local businesses depend on reliable equipment. We repair premium residential appliances and provide commercial appliance repair for offices, shops and restaurants.",
    local: "Oak Brook is a DuPage County village known for Oakbrook Center shopping and large corporate offices.",
  },
  "orland-park": {
    name: "Orland Park", county: "Cook", zips: ["60462", "60467"],
    near: ["crestwood", "mokena", "palos-heights"],
    intro: "Orland Park is a large, busy suburb with thousands of homes, and we are ready to help with appliance problems of every kind. Our technicians repair all major brands, and every repair includes a warranty.",
    local: "Orland Park is a large southwest suburb in Cook County and is home to Orland Square Mall.",
  },
  "palos-heights": {
    name: "Palos Heights", county: "Cook", zips: ["60463"],
    near: ["palos-hills", "crestwood", "orland-park"],
    intro: "Palos Heights residents trust us to repair refrigerators, ranges, dishwashers and laundry appliances without fuss. You get a clear quote up front, and the service fee is waived when you go ahead with the repair.",
    local: "Palos Heights is a Cook County city in the southwest suburbs known for Lake Katherine Nature Center.",
  },
  "palos-hills": {
    name: "Palos Hills", county: "Cook", zips: ["60465"],
    near: ["palos-heights", "hickory-hills", "orland-park"],
    intro: "From a leaking washer to a stove that won't light, Palos Hills homeowners can call us for fast diagnosis and repair. We stand behind our work with a parts and labor warranty.",
    local: "Palos Hills is a Cook County city in the southwest suburbs, near Palos Heights and Hickory Hills.",
  },
  "plainfield": {
    name: "Plainfield", county: "Will", zips: ["60544", "60585", "60586"],
    near: ["shorewood", "naperville", "bolingbrook"],
    intro: "Plainfield is our home base, so we know the area well and can often get to you quickly. We repair refrigerators, washers, dryers, dishwashers, ovens, stoves and wine coolers for homes and businesses.",
    local: "Plainfield is a fast-growing Will County village and the headquarters of AT Appliance Repair and Maintenance.",
  },
  "prospect-heights": {
    name: "Prospect Heights", county: "Cook", zips: ["60070"],
    near: ["arlington-heights", "schaumburg", "barrington"],
    intro: "Prospect Heights homeowners and renters can count on us for dependable appliance repair. We handle everyday problems like noisy fridges, slow dryers and dishwashers that will not drain.",
    local: "Prospect Heights is a northwest Cook County city near Arlington Heights and Wheeling.",
  },
  "romeoville": {
    name: "Romeoville", county: "Will", zips: ["60446"],
    near: ["bolingbrook", "lockport", "plainfield"],
    intro: "Romeoville has a mix of houses, townhomes and rental properties, and we repair appliances in all of them. Landlords and property managers can also call us to arrange repairs across several units.",
    local: "Romeoville is a Will County village that is home to Lewis University.",
  },
  "schaumburg": {
    name: "Schaumburg", county: "Cook", zips: ["60173", "60193", "60194", "60195"],
    near: ["arlington-heights", "bartlett", "barrington"],
    intro: "Schaumburg is both a residential community and a major business center. We repair household appliances and provide commercial appliance repair for restaurants, hotels, offices and shops.",
    local: "Schaumburg is a large northwest suburb in Cook County known for Woodfield Mall.",
  },
  "shorewood": {
    name: "Shorewood", county: "Will", zips: ["60404"],
    near: ["plainfield", "crest-hill", "new-lenox"],
    intro: "Shorewood is close to our Plainfield base, which makes scheduling a repair simple. We repair refrigerators, dryers, dishwashers and ovens, and we give the price before any work begins.",
    local: "Shorewood is a Will County village between Plainfield and Joliet.",
  },
  "villa-park": {
    name: "Villa Park", county: "DuPage", zips: ["60181"],
    near: ["elmhurst", "addison", "glen-ellyn"],
    intro: "Villa Park has many established neighborhoods where appliances have seen years of use. We can usually tell you quickly whether a repair is worthwhile, and we guarantee our work.",
    local: "Villa Park is a DuPage County village near Elmhurst and Lombard with many established neighborhoods.",
  },
  "wheaton": {
    name: "Wheaton", county: "DuPage", zips: ["60187", "60189"],
    near: ["glen-ellyn", "lisle", "addison"],
    intro: "Wheaton residents call us for dependable repairs on refrigerators, washers, dryers, dishwashers and ovens. We arrive ready to diagnose, explain the options and complete most repairs in one visit.",
    local: "Wheaton is the DuPage County seat and is home to Wheaton College.",
  },
  "western-springs": {
    name: "Western Springs", county: "Cook", zips: ["60558"],
    near: ["hinsdale", "clarendon-hill", "willow-springs"],
    intro: "Western Springs homes include many well-kept older houses, and their owners like to repair appliances rather than replace them when they can. We help you make that decision with a clear, honest quote.",
    local: "Western Springs is a Cook County village known for its historic water tower and Metra station.",
  },
  "willow-springs": {
    name: "Willow Springs", county: "Cook", zips: ["60480"],
    near: ["western-springs", "hickory-hills", "palos-hills"],
    intro: "Willow Springs is a small village, but its homes depend on their appliances just the same. We offer prompt repair of refrigerators, ovens, washers and dryers with an upfront price.",
    local: "Willow Springs is a small Cook County village near the forest preserves and the Des Plaines River valley.",
  },
};